import { render, staticRenderFns } from "./BuyingContentCard.vue?vue&type=template&id=7f2e8f58&scoped=true&"
import script from "./BuyingContentCard.vue?vue&type=script&lang=js&"
export * from "./BuyingContentCard.vue?vue&type=script&lang=js&"
import style0 from "./BuyingContentCard.vue?vue&type=style&index=0&id=7f2e8f58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e8f58",
  null
  
)

export default component.exports